import { Helpers } from '../../helpers';
import { ICompletionDesign } from '../../interfaces/icompletion-design';
import { AssetTeam } from '../asset-team';
import { FluidSystem } from '../fluid-system';
import { PerforatingScheme } from '../perforating-scheme';
import { ProjectCompletionsParameter } from '../project-completions-parameter';
import { ProjectCompletionsParmetersCompletionDesign } from '../project-completions-parmeters-completion-design';
import { ProppantType } from '../proppant-type';
import { ScenarioWell } from '../scenario-well';
import { Well } from '../well';

export class CompletionDesignBase {
  CompletionDesignId: number;
  Name: string;
  Alias: string | null;
  StageLength: number | null;
  SortOrder: number | null;
  AssetTeamId: number;
  FluidSystemId: number | null;
  LinearGelPct: number | null;
  CrossLinkPct: number | null;
  SlickWaterPct: number | null;
  ClustersPerStage: number | null;
  ClusterSpacing: number | null;
  StimEfficiency1: number | null;
  StimEfficiency2: number | null;
  StimEfficiency3: number | null;
  CostMatrixInput: boolean;
  FluidQuantity: number;
  ProppantPoundsPerFt: number | null;
  ProppantType1ItemId: number | null;
  ProppantType1Percent: number | null;
  ProppantType2ItemId: number | null;
  ProppantType2Percent: number | null;
  ProppantType3ItemId: number | null;
  ProppantType3Percent: number | null;
  ProppantType4ItemId: number | null;
  ProppantType4Percent: number | null;
  ProppantType5ItemId: number | null;
  ProppantType5Percent: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  SentToP6: Date | null;
  ReceivedByP6: Date | null;
  PerforatingSchemeId: number | null;
  PerforationQuantity: number | null;

  ProjectCompletionsParameters_CompletionDesign?: Array<ProjectCompletionsParameter> | null;
  ProjectCompletionsParmetersCompletionDesigns_CompletionDesign?: Array<ProjectCompletionsParmetersCompletionDesign> | null;
  ScenarioWells_CompletionDesign?: Array<ScenarioWell> | null;
  Wells_CompletionDesign?: Array<Well> | null;
  Wells_StandardCompletionDesign?: Array<Well> | null;
  AssetTeam?: AssetTeam;
  FluidSystem?: FluidSystem;
  PerforatingScheme?: PerforatingScheme;
  ProppantType1Item?: ProppantType;
  ProppantType2Item?: ProppantType;
  ProppantType3Item?: ProppantType;
  ProppantType4Item?: ProppantType;
  ProppantType5Item?: ProppantType;

  constructor(item?: ICompletionDesign) {
    if (item) {

      this.CompletionDesignId = item.CompletionDesignId;
      this.Name = item.Name;
      this.Alias = item.Alias;
      this.StageLength = item.StageLength;
      this.SortOrder = item.SortOrder;
      this.AssetTeamId = item.AssetTeamId;
      this.FluidSystemId = item.FluidSystemId;
      this.LinearGelPct = item.LinearGelPct;
      this.CrossLinkPct = item.CrossLinkPct;
      this.SlickWaterPct = item.SlickWaterPct;
      this.ClustersPerStage = item.ClustersPerStage;
      this.StimEfficiency1 = item.StimEfficiency1;
      this.StimEfficiency2 = item.StimEfficiency2;
      this.StimEfficiency3 = item.StimEfficiency3;
      this.CostMatrixInput = item.CostMatrixInput;
      this.FluidQuantity = item.FluidQuantity;
      this.ProppantPoundsPerFt = item.ProppantPoundsPerFt;
      this.ProppantType1ItemId = item.ProppantType1ItemId;
      this.ProppantType1Percent = item.ProppantType1Percent;
      this.ProppantType2ItemId = item.ProppantType2ItemId;
      this.ProppantType2Percent = item.ProppantType2Percent;
      this.ProppantType3ItemId = item.ProppantType3ItemId;
      this.ProppantType3Percent = item.ProppantType3Percent;
      this.ProppantType4ItemId = item.ProppantType4ItemId;
      this.ProppantType4Percent = item.ProppantType4Percent;
      this.ProppantType5ItemId = item.ProppantType5ItemId;
      this.ProppantType5Percent = item.ProppantType5Percent;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.SentToP6 = item.SentToP6 ? new Date(item.SentToP6) : null;
      this.ReceivedByP6 = item.ReceivedByP6 ? new Date(item.ReceivedByP6) : null;
      this.PerforatingSchemeId = item.PerforatingSchemeId;
      this.PerforationQuantity = item.PerforationQuantity;

      this.ProjectCompletionsParameters_CompletionDesign = Helpers.createClassArray(ProjectCompletionsParameter, item.ProjectCompletionsParameters_CompletionDesign);
      this.ProjectCompletionsParmetersCompletionDesigns_CompletionDesign = Helpers.createClassArray(ProjectCompletionsParmetersCompletionDesign, item.ProjectCompletionsParmetersCompletionDesigns_CompletionDesign);
      this.ScenarioWells_CompletionDesign = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_CompletionDesign);
      this.Wells_CompletionDesign = Helpers.createClassArray(Well, item.Wells_CompletionDesign);
      this.Wells_StandardCompletionDesign = Helpers.createClassArray(Well, item.Wells_StandardCompletionDesign);
      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.FluidSystem = new FluidSystem(item.FluidSystem);
      this.PerforatingScheme = new PerforatingScheme(item.PerforatingScheme);
      this.ProppantType1Item = new ProppantType(item.ProppantType1Item);
      this.ProppantType2Item = new ProppantType(item.ProppantType2Item);
      this.ProppantType3Item = new ProppantType(item.ProppantType3Item);
      this.ProppantType4Item = new ProppantType(item.ProppantType4Item);
      this.ProppantType5Item = new ProppantType(item.ProppantType5Item);
    }
  }
}